import {Button, Space} from "antd";
import {PlusCircleFilled} from "@ant-design/icons";
import {useFieldArray, useFormContext} from "react-hook-form";
import {OfferingFormCheckoutFormValues} from "../../types";
import {Reorder} from "framer-motion";
import {reorderList} from "../../utils";
import {OfferingFormCheckoutFormAddedQuestionItem} from "./item";

export function OfferingFormCheckoutFormAddedQuestions() {
  const {control} = useFormContext<OfferingFormCheckoutFormValues>();
  const {fields, append, remove, move} = useFieldArray({
    control,
    name: "bookingQuestions",
  });
  return (
    <div>
      <Space size={24} direction="vertical" style={{display: "flex"}}>
        <div>
          <Reorder.Group
            style={{
              listStyle: "none",
              padding: 0,
            }}
            axis="y"
            onReorder={(newFields) => reorderList(newFields, fields, move)}
            values={fields}
          >
            <Space direction="vertical" size={24} style={{display: "flex"}}>
              {fields.map((item, index) => (
                <OfferingFormCheckoutFormAddedQuestionItem
                  key={item.id}
                  item={item}
                  index={index}
                  remove={remove}
                />
              ))}
            </Space>
          </Reorder.Group>
        </div>
        <Button
          icon={<PlusCircleFilled />}
          onClick={() => {
            console.log({fields});
            append({
              question: "",
              answerType: "short-text",
              required: false,
              options: [],
            });
          }}
          size="small"
        >
          Add question
        </Button>
      </Space>
    </div>
  );
}
